<template>
    <section>
        <PageTitle :title=" (loggedInRole!=='') ?  (loggedInRole !== 'ROLE_BRANCH') ? 'All Orders' : 'All Processed Orders' : ''" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/orders',title:'orders'}]" v-if="!notFromBranch"/>
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title" v-if="!notFromBranch">
                        <h5 v-if="loggedInRole !== 'ROLE_BRANCH'">All Orders</h5>
                        <h5 v-else>All Processed Orders</h5>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                  <label>Orders Filter</label>
                                  <multiselect :options="orderCategories"
                                               v-model="selectedOrderCategory"
                                               track-by="value"
                                               :allow-empty="false"
                                               label="name"
                                               @close="resetData"
                                               />
                                </div>
                            </div>
                            <div class="col-md-3 h-90">
                              <div class="form-group">
                                <label>Order Id</label>
                                <input placeholder="Order Id" id="orderId" class="form-control" />
                              </div>
                            </div>
                            <div class="col-md-3 h-90">
                              <div class="form-group">
                                <SearchCustomerByNameAndContactNumber
                                    ref="searchCustomerMultiselect"
                                    :bayked-orders=baykedOrders
                                    @selectedCustomer="(event) => this.selectedCustomerTemp = event" />
                              </div>
                            </div>
                            <div class="col-md-3 h-90">
                              <AllRestaurants
                                  :updateSelectedRestaurant="selectedRestaurant"
                                  :testRestaurantOnly="!showTestOrders"
                                  :where="'orders'"
                                  :placeholder="'Select Restaurants'"
                                  :return-value="''"
                                  @update:selectedRestaurantId="fetchBranchesOfRestaurant"/>
                            </div>
                            <div class="col-md-3 h-90" v-if="loggedInRole !== 'ROLE_BRANCH'">
                                <div class="form-group">
                                    <label>Branches</label>
                                    <select id="filter2" v-model="selectedBranch"  class="form-control" >
                                        <option value="">Select Branch</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id+'_branchchoose'">
                                            {{branch.areasByAreaId.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 h-90" v-if="loggedInRole !== 'ROLE_BRANCH'">
                                <div class="form-group">
                                    <label>City</label>
                                    <select id="filter4" required="required" v-model="selectedCity" class="form-control">
                                        <option value="">Select City</option>
                                        <option v-for="city in cities" v-bind:key="'city_sel_'+city.id" v-bind:value="city.id">{{city.city}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 h-90" v-if="loggedInRole !== 'ROLE_BRANCH' && !baykedOrders">
                              <div class="form-group">
                                <label>Area <b v-if="selectedCity === ''" class="text-danger text-sm">(select city)</b></label>
                                <multiselect id="areaMultiselect"
                                             :options="areas"
                                             :disabled="(selectedCity === '')"
                                             v-model="selectedAreaTemp"
                                             placeholder="Select Area"
                                             track-by="name"
                                             label="name"
                                             :hideSelected="true"
                                             :max-height="150"
                                             @close="checkTheLengthOfSelectedArea"
                                             @search-change="debounceInput">
                                </multiselect>
                              </div>
                            </div>
                            <div class="col-md-3 h-90">
                              <search-coupon-by-coupon-code
                                  ref="searchCouponByWildCard"
                                  @selectedCoupon="(event) => this.selectedCouponTemp = event"
                              />
                            </div>
                            <div class="col-md-3 h-90">
                                <div class="form-group">
                                    <label>Created</label>
                                    <input id="filter6" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div class="col-md-3 h-90">
                                <div class="form-group">
                                    <label>Status</label>
                                    <select id="filter7" class="form-control">
                                      <option value="">Select Order Status</option>
                                      <option v-for="status in statuses"  v-bind:value="status.id">{{status.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 h-90" v-if="!baykedOrders && (loggedInRole==='ROLE_ADMIN' || loggedInRole==='ROLE_AGENT')">
                                <div class="form-group">
                                  <label>Select User/Agent</label>
                                  <multiselect v-model="selectedAgent"
                                               :options="fullNames"
                                               placeholder="Select User/Agents"
                                               track-by="fullName"
                                               label="fullName"
                                               />
                                </div>
                            </div>
                            <div class="col-md-3 h-90">
                                <div class="form-group">
                                    <label>Order Type</label>
                                    <select id="filter9" class="form-control">
                                        <option value="">Select Order Type</option>
                                        <option v-for="type in orderTypes" v-if="(baykedOrders && type.id !== 2) || (!baykedOrders)" v-bind:value="type.id">{{type.type}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 h-90"  v-if="!baykedOrders">
                                <label>Order Source</label>
                                <select name="filter10" id="filter10" class="form-control" v-model="selectedSource" :disabled="baykedOrders">
                                    <option value="">Select Order Source</option>
                                    <option v-for="orderSource in orderSources" :value="orderSource.id" :key="orderSource.id">{{orderSource.source}}</option>
                                </select>
                            </div>
                            <div class="col-md-3 h-90">
                              <label>Payment Method</label>
                              <select name="filter11" id="filter11" class="form-control">
                                <option value="" disabled selected>Select Payment Method</option>
                                <option v-for="paymentMethod in paymentMethods" :value="paymentMethod.id" :key="paymentMethod.id">{{paymentMethod.name}}</option>
                              </select>
                            </div>
                            <div class="col-md-3 h-90">
                              <label>Payment Status</label>
                              <select name="filter12" id="filter12" class="form-control">
                                <option value="" disabled selected>Select Payment Status</option>
                                <option v-for="paymentStatus in paymentStatuses" :value="paymentStatus.id" :key="paymentStatus.id">{{paymentStatus.name}}</option>
                              </select>
                            </div>
                            <div class="col-md-3 h-90" v-if="showFoodPandaOrderIdFilter">
                                <div class="form-group">
                                    <label>Foodpanda Order Id</label>
                                    <input type="text" placeholder="Foodpanda Order Id" id="FoodPandaOrderId" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 h-90">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px; margin-right: 10px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
                                <button style="margin-top: 25px; margin-right: 10px" class="btn btn-warning btn-sm search_filter_order_btn" data-toggle="modal" v-if="isSuperAdmin" @click="loadExportOrderModal" type="button"><i class="fa fa-download"></i> Export CSV</button>
                            </div>
                        </div>
                        <hr/>
                      <div class="float-right" v-if="loggedInRole==='ROLE_ADMIN'">
                        <a href="javascript:void(0)">
                          <label>Test Orders:&nbsp;</label>
                          <i v-if="showTestOrders"
                             class="fa fa-toggle-on fa-lg"
                             title="show"
                             @click="toggleTestOrders"
                          />
                          <i v-else
                             class="fa fa-toggle-off fa-lg"
                             title="hide"
                             @click="toggleTestOrders"
                          />
                        </a>
                      </div>
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover" id="dtTable">
                                <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Restaurant</th>
                                    <th>Branch</th>
                                    <th>Customer Name</th>
                                    <th>Customer Area</th>
                                    <th>City</th>
                                    <th>Total Amount</th>
                                    <th>Created</th>
                                    <th>Modified</th>
                                    <th>Order Type</th>
                                    <th>Order Source</th>
                                    <th>Assigned slot</th>
                                    <th>Payment Method</th>
                                    <th>Payment Status</th>
                                    <th>Taken By</th>
                                    <th>Status</th>
                                    <th class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                                </thead>
                                <tbody>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewOrder showActions="true" :orderStatuses="orderStatuses" ref="viewOrderComp"/>
      <ExportOrders :filters="filters" ref="exportOrder"/>
    </section>
</template>

<script>
/* eslint-disable */
import PageTitle from '@/components/layout_components/PageTitle'
import ViewOrder from '@/components/orders/ViewOrder'
import Multiselect from 'vue-multiselect'
import {debounce} from 'lodash';
import {getAllAreasUsingWildCard} from "../api/areas";
import {getOrderPaymentStatuses} from "../api/orders";
import AllRestaurants from "../components/restaurants/AllRestaurants";
import moment from "moment";
import SearchCustomerByNameAndContactNumber from "../components/utils/SearchCustomerByNameAndContactNumber";
import SearchCouponByCouponCode from "../components/utils/SearchCouponByCouponCode";
import ExportOrders from "@/components/orders/ExportOrders.vue";


export default {
        name: "Orders",
        data() {
            return {
                orderCategories: [
                  {
                    "name": "DVM Orders",
                    "value" : false
                  },
                  {
                    "name": "Bayked Orders",
                    "value": true,
                  }
                ],
                selectedOrderCategory: "",
                orderStatuses: [],
                fullNames: [],
                restaurants: [],
                branches: [],
                cities: [],
                areas: [],
                coupons: [],
                orderTypes: [],
                selectedRestaurant: "",
                selectedBranch: "",
                selectedCity: '',
                loggedInRole: "",
                defaultRestaurant: "",
                selectedCustomerTemp: "",
                selectedCouponTemp: null,
                selectedCustomer: "",
                orderSources:[],
                paymentMethods:[],
                paymentStatuses:[],
                selectedStatus:'',
                dtTable:'',
                baykedOrders: false,
                selectedArea: "",
                selectedAreaTemp: "",
                debounceInput: null,
                debounceCustomerInput: null,
                debounceCouponInput: null,
                couponCode: "",
                selectedAgent: "",
                showTestOrders: false,
                showFoodPandaOrderIdFilter: false,
                selectedSource: "",
                filters: "",
            }
        },
        props: {
          notFromBranch: {
            type: Boolean,
            default: false,
          },
        },
        components: {
          ExportOrders,
            AllRestaurants,
            PageTitle,
            ViewOrder,
            Multiselect,
            SearchCustomerByNameAndContactNumber,
            SearchCouponByCouponCode
        },
        computed: {
            statuses() {
                if (this.loggedInRole === 'ROLE_BRANCH') {
                    return this.orderStatuses.filter(fn => {
                        return (fn.id !== 1 && fn.id !== 2 && fn.id !== 7);
                    })
                }
                return this.orderStatuses;
            },
            isSuperAdmin() {
                const allowedUserIds = [916, 50, 53, 946, 1542, 235];
                const currentUserID = this.$store.getters.user.id;

                return allowedUserIds.includes(currentUserID) || this.loggedInRole === "ROLE_USER";

                // 916 => adnan husnain
                // 50 => salman yousaf
                // 53 => talal anwar
                // 946 => mahnoor feroz
            }
        },
        watch: {
          selectedOrderCategory: {
            handler() {
              if(this.selectedOrderCategory !== {}){
                this.baykedOrders = this.selectedOrderCategory && this.selectedOrderCategory.value;
              }
            },
          },
          selectedSource : {
            handler(val) {
              this.showFoodPandaOrderIdFilter = !this.baykedOrders && val === 7
            },
          },
          baykedOrders (val) {
            this.selectedCustomerTemp = null
            this.$refs.searchCustomerMultiselect.customers = []
            this.$refs.searchCustomerMultiselect.selectedCustomerTemp = null
            this.selectedCouponTemp = null
            this.$refs.searchCouponByWildCard.coupons = []
            this.$refs.searchCouponByWildCard.selectedCouponTemp = null
          }
        },
        created: async function () {
          this.debounceInput = debounce(this.searchArea, 500);
          this.loggedInRole = this.$store.getters.user.userRolesById[0].role;
          this.$http.get(this.$store.state.mainAppURL + "users/get_all_users_full_name").then(resp => {
            this.fullNames = this.filteredUsersName(resp.data);
          });
          this.$http.get(this.$store.state.mainAppURL + "statuses/get_all_statuses").then(resp => {
            this.orderStatuses = resp.data;
          });
          this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_source").then(resp => {
            this.orderSources = resp.data;
          });
          this.$http.get(this.$store.state.mainAppURL + "orders/get_all_payment_method").then(resp => {
            this.paymentMethods = resp.data;
          });
          let res = await getOrderPaymentStatuses().catch(ex => {
                this.showErrorMessage(ex)
              }
          );
          this.paymentStatuses = res.data.body;
          this.$http.post(this.$store.state.mainAppURL + "areas/get_all_cities").then(resp => {
            this.cities = resp.data;
          });
          this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_types").then(resp => {
            this.orderTypes = resp.data;
          });
        },
        mounted: function (){
            let self = this;
            this.getDefaultOrdersCategory()
          $("#filter4").change(function () {
              self.areas = [];
              self.selectedArea = "";
            })
            if(this.$route.query.order_id !== undefined){
                this.$refs.viewOrderComp.fetchOrderDetail(this.$route.query.order_id);
            }
            this.showLoadingOnDataTables();
            let processingURL = this.$store.state.mainAppURL + "orders/all_paged_orders";
            this.dtTable = $('#dtTable').DataTable({
            "createdRow": function ( row, data, index ) {
                    if(data.customerAddressesByCustomerAddressId===null && data.dvmAddress===null && self.loggedInRole === 'ROLE_AGENT'){
                        $(row).hide();
                    }
                },
                "processing": true,
                "serverSide": true,
                "autoWidth": false,
                "scrollX": true,
                "pagingType": "simple",
                "dom":'ltipr',
                "order": [[0, "desc"]],
                "pageLength": 100,
                "lengthMenu": [10, 25, 50, 100, 250],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        if (self.loggedInRole==='ROLE_ADMIN' || self.loggedInRole==='ROLE_AGENT') {
                          d.showTestOrders = self.showTestOrders
                        }
                        d.bayked_orders = self.selectedOrderCategory.value;
                        d.orderId = $("#orderId").val();
                        d.customerId = self.selectedCustomerTemp ? self.selectedCustomerTemp.id : "";
                        d.couponId = self.selectedCouponTemp ? self.selectedCouponTemp.id : "";
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr, settings) => {
                      self.filters = settings.data
                      xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(this.dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4,5,9,10,11,12] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9,10,11,12] },
                ],
                "columns": [
                    { "data": "orderId", "name":"id" },
                    { "data": "restaurantName","name":"restaurant_name" },
                    { "data": "branchName","name":"branch_area" },
                    {
                        "data": "customerName",
                        "name": "customer_name",
                        "render": function (data, type, row) {
                          if (row.baykedCustomerName !== null) {
                            return row.baykedCustomerName;
                          } else if (row.customerName !== null) {
                            return row.customerName;
                          } else {
                            return "N/A";
                          }
                        }
                    },
                    {
                         "data": "areaName",
                         "name":"customer_area",
                         "render": function(data, type, row){
                             if(row.orderTypesId !== 3){
                                 return "N/A";
                             }return data;
                         }
                    },
                    {
                        "data": "cityName",
                        "name":"customer_city",
                         "render": function(data, type, row){
                           if(row.orderTypesId !== 3){
                             return "N/A";
                           }return data;
                         },
                    },
                    { "data": "billedPrice","name":"billedPrice" },
                    {
                        "data": "orderCreated",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "orderModified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "orderTypeName",
                        "name":"orderType"
                    },
                    {
                        "data": "orderSourceName",
                        "name": "orderSource",
                        "render": function(data) {
                            if(data===null){
                                return "N/A";
                            }else{
                                return data;
                            }
                        }
                    },
                    {
                        "data": "assignedSlot",
                        "name": "assignedSlot",
                        "render": function(data, type, row) {
                          if(row.tableName){
                            return row.tableName;
                          }else{
                            return 'N/A';
                          }
                        }
                    },
                    {
                      "data": "paymentMethodName",
                      "name": "paymentMethodName",
                      "render": data => data ?data : 'N/A'
                    },
                  {
                    "data": "paymentStatusName",
                    "name": "paymentStatusName",
                    "render": data => data ?data : 'N/A'
                  },
                    {
                        "data": "agentName",
                        "name":"TakenBy",
                        "render": function(data, type, row){
                            if(data===null){
                                return "Baked App Order"
                            }else{
                                return data;
                            }
                        }
                    },
                    {
                        "data": "cssClass",
                        "render": function(data, type, row){
                            return "<span class='label "+row.cssClass+"'>"+row.statusName+"</span>";
                        },
                        "name":"status"
                    },
                    {
                        "data": "actions",
                        "render": function(data, type, row){
                            return '<a data-id="'+row.orderId+'" class="btn btn-xs btn-primary view_btn" href="javascript:void(0)">View</a>';
                        },
                        "name":"actions"
                    },

                ],
                "rowCallback": function (row, data){
                    if(data.complainCount > 0){
                        $(row).addClass("danger");
                     }
                },
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".view_btn").click( function() {
                        let orderId = $(this).attr("data-id");
                        self.fetchOrderDetail(orderId);
                    });
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_filter_order_btn").click(function(){
                for(var i = 1; i <= 10; i++){
                  self.dtTable.column(i).search($("#filter" + i).val());
                }
                self.dtTable.column(4).search(self.selectedArea.id ? self.selectedArea.id : "");
                self.dtTable.column(5).search(self.selectedCity);
                self.dtTable.column(1).search(self.selectedRestaurant)
                self.dtTable.column(7).search( self.selectedStatus.id );
                self.dtTable.column(8).search(self.selectedAgent.fullName);
                self.dtTable.column(11).search($("#filter11").val() ? $("#filter11").val() : '');
                self.dtTable.column(12).search($("#filter12").val() ? $("#filter12").val() : '');
                self.dtTable.column(13).search($("#FoodPandaOrderId").val() ? $("#FoodPandaOrderId").val() : '');
                self.dtTable.draw();
            });
            $(".refresh_filter_order_btn").click(function(){
              self.resetData();
              self.dtTable.draw();
            });
            $('.date_picker').daterangepicker({
                format: 'YYYY-MM-DD',
                maxDate: new Date,
                minDate: moment().subtract(3,'M')
            }).on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
            }).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
            });
            setTimeout(function(){
                $(".dataTables_processing").css("top", "3%");
             }, 0);
        },
        methods: {
            getDefaultOrdersCategory: function (){
              this.selectedOrderCategory = this.orderCategories[0]
            },
            filteredUsersName: function (users) {
                if(this.loggedInRole==='ROLE_AGENT'){
                    if(users.length>0){
                        return users.filter(fn=>{
                            return fn.role==='ROLE_AGENT';
                        });
                    }
                }else{
                    return users;
                }
            },
            setOrderIdAndContactNumber(orderId= '', contactNumber = ''){
              $("#orderId").val(orderId);
            },
            resetData: function (){
              for(var i=1; i <= 13; i++){
                $("#filter" + i).val( '' );
                this.dtTable.column(i).search( '' );
              }
              this.setOrderIdAndContactNumber();
              this.areas = [];
              this.selectedArea = "";
              this.selectedAreaTemp = "";
              this.selectedCouponTemp = null;
              this.selectedCustomerTemp = "";
              this.selectedBranch = "";
              this.selectedRestaurant = this.defaultRestaurant;
              this.selectedCity = "";
              this.selectedCustomer = "";
              this.selectedAgent = "";
              this.branches = [];
              this.couponCode = "";
              this.selectedSource = "";
              this.$refs.searchCustomerMultiselect.selectedCustomerTemp = null;
              this.$refs.searchCustomerMultiselect.customers = [];
              this.$refs.searchCouponByWildCard.selectedCouponTemp = null;
              this.$refs.searchCouponByWildCard.coupons = []

            },
            checkTheLengthOfSelectedArea: function (){
              if(this.selectedAreaTemp != null && this.selectedAreaTemp !== "") {
                this.selectedArea = this.selectedAreaTemp;
                if (this.selectedAreaTemp.name.length > 30) {
                  this.selectedAreaTemp.name = this.selectedAreaTemp.name.substring(0, 30) + "....";
                }
              }
            },
            searchArea: async function () {
              let wild_card = $("#areaMultiselect").val();
              if(wild_card !== "") {
                let params = new URLSearchParams();
                params.append("wild_card", wild_card);
                params.append("city_id", this.selectedCity);
                let allAreasResp = await getAllAreasUsingWildCard(params);
                this.areas = allAreasResp.data;
              }
            },
            fetchOrderDetail: function (orderId) {
                this.$refs.viewOrderComp.fetchOrderDetail(orderId);
            },
            fetchBranchesOfRestaurant: function (event) {
                this.selectedRestaurant = event;
                if(this.selectedRestaurant !== ''){
                  let params = new URLSearchParams();
                  params.append("restaurant_id", this.selectedRestaurant);
                  this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                    this.branches = resp.data;
                  });
                }else{
                  this.branches = [];
                }
                this.selectedBranch = "";
            },
            toggleTestOrders() {
              this.showTestOrders = !this.showTestOrders
              this.dtTable.draw();
            },
            loadExportOrderModal() {
              if (this.selectedRestaurant !== "") {
                $("#exportModal").modal("show");
              } else {
                setTimeout(() => {
                  swal("Error!", "Kindly Select Restaurant First", "error");
                }, 1000)
              }
            }
        }
    }
</script>

<style scoped>
.form-control{
  height: 40px;
}
.h-90 {
  height: 80px;
}
.float-right{
  float: right;
}
</style>
